import React from 'react'
import { initials } from '../../utility/common-methods'

export default function Initials({ name, className }) {
  return (
    <div className="circle">
      <div className="initials">
        {initials(name)}
      </div>
    </div>
  )
}
